import { configureStore } from '@reduxjs/toolkit';
import landingGridsReducer from './landingGridsSlice';
export const store = configureStore({
    reducer: {
        landingGrids: landingGridsReducer,
    },
});
